var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrunchbaseScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02d7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#0287d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0258ae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.52136,58.51648h-5.40393c-1.57672,3.44635-5.64551,4.9718-9.08948,3.39508v-.00238c-4.36163-1.98431-5.40387-7.71771-2.00873-11.09827,3.38287-3.39508,9.11389-2.35052,11.09821,2.00879h5.40393c-3.36835-13.80511-23.67078-11.36432-23.67078,2.84839,0,14.2005,20.30243,16.64124,23.67078,2.84839Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.28503,43.64227c-2.09662.16595-4.11761.86646-5.86035,2.04779v-13.37305h-4.88153v34.40045h4.92059v-1.24469c3.25598,2.19916,7.3736,2.65546,11.02258,1.24469,1.27167-.48328,2.42859-1.16901,3.45856-2.06l-.00238-.00238c8.44031-7.2077,3.32916-21.03723-7.78119-21.01282h-.87628ZM70.21997,55.65839c.07568,3.83936-3.0119,7.00507-6.85126,7.00507s-6.92938-3.16571-6.83911-7.00507c.19037-8.92352,13.48779-8.92352,13.69037,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbaseScraper);
export default __webpack_public_path__ + "static/media/crunchbase-scraper.d9ca6474577a81afeda0a7b5a4a123c6.svg";
export { ForwardRef as ReactComponent };